import { OrmModel, AttrField, StringField, NumberField, BooleanField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import type { RecipientOption } from '@/services/domain/messages/types'
import type { ComposeSchedule } from '@/services/forms/baseScheduleFormService'
import type { ComposeLocalLabel } from '@/services/types'

@OrmModel(modelNames.COMPOSE_LOCAL)
export default class ComposeLocal extends BaseModel {
  @StringField()
  public id: string

  @AttrField([])
  public recipients: Array<RecipientOption>

  @NumberField(0)
  public recipientsCount: number

  @StringField('')
  public message: string

  @StringField('')
  public sender: string

  @StringField(new Date().toISOString())
  public updatedAt: string

  @BooleanField()
  public sendLater: boolean

  @AttrField()
  public schedule: ComposeSchedule | null
  @AttrField([])
  public labels?: ComposeLocalLabel[]

  @NumberField(0)
  public version: number
}
